jQuery(document).ready(function ($) {
    if ($('#map').length < 1) {
        return;
    }

    const markersData = window.markersData;

    if (typeof markersData == 'undefined') {
        return;
    }

    // Get current language from i18n object
    const currentLanguage = (window.i18n && window.i18n.lang) ? window.i18n.lang : 'nl';
    
    // Set map center and zoom based on language
    // Default to Netherlands (Amsterdam), but use center of Germany for German language
    let mapCenter;
    let mapZoom;
    if (currentLanguage === 'de') {
        mapCenter = { lat: 51.1657, lng: 10.4515 }; // Center of Germany
        mapZoom = 6; // Zoomed out by 2 levels (from 8 to 6)
    } else {
        mapCenter = { lat: 52.3676, lng: 4.9041 }; // Amsterdam center (Netherlands)
        mapZoom = 8;
    }

    // Wait for Google Maps API to load
    let retryCount = 0;
    const maxRetries = 50; // Maximum 5 seconds (50 * 100ms)
    
    function initializeMap() {
        // Check if Google Maps is loaded
        if (typeof google === 'undefined' || typeof google.maps === 'undefined' || typeof google.maps.Map === 'undefined') {
            retryCount++;
            if (retryCount >= maxRetries) {
                // console.error('Google Maps API failed to load after maximum retries');
                return;
            }
            // Retry after a short delay
            setTimeout(initializeMap, 100);
            return;
        }

        // Initialize the Google map
        const map = new google.maps.Map(document.getElementById('map'), {
        center: mapCenter,
        zoom: mapZoom,
        styles: [
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    { "visibility": "on" },
                    { "color": "#2B673C" },
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    { "visibility": "simplified" }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    { "color": "#ffffff" },
                    { "weight": 0.8 }
                ]
            },          
            {
                "featureType": "administrative.country",
                "elementType": "labels.text",
                "stylers": [
                    { "visibility": "on" },
                    { "color": "#ffffff" },
                    { "weight": 0.8 }
                ]
            },
            {
                "featureType": "road",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.icon",
                "stylers": [
                    { "visibility": "simplified" },
                    { "color": "#ffffff" }
                ]
            },
            {
                "featureType": "administrative.province",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    { "visibility": "simplified" },
                    { "color": "#B4C28B" }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    { "color": "#ffffff" } // Set label text color to white
                ]
            }
        ]
        });

        const markers = [];
        const infoWindow = new google.maps.InfoWindow();

        function displayMarkers(data) {
            const customIcon = {
                url: window.postalCodeAjax.pin,
                scaledSize: new google.maps.Size(38, 52),
                anchor: new google.maps.Point(19, 52),
            };

            data.forEach(entry => {
                const { coords, name, address } = entry;
                const marker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(coords.lat),
                        lng: parseFloat(coords.lng)
                    },
                    map: map,
                    title: name,
                    icon: customIcon,
                });

                let adr = address.split(',').map(item => `<p>${item.trim()}</p>`).join('');
                   // Add click listener to marker
                   marker.addListener('click', () => {
                    const content = `
                        <div class="a-infoWindow">
                            <span>${name}</span>
                            ${adr}
                        </div>
                    `;
                    
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);
                });

                markers.push(marker);
            });
        }

        displayMarkers(markersData);

        // Handle form submission
        const $form = $('#postalCodeForm');
        const $formError = $('#postalCodeFormError');

        $form.on('submit', function (e) {
            e.preventDefault();

            if ($form.hasClass('-busy')) {
                return;
            }

            $formError.hide();

            $form.addClass('-busy');

            const postalCode = $('#postalCode').val();

            if (postalCode == '') {
                return;
            }

            // Perform AJAX request
            const req = $.ajax({
                url: window.postalCodeAjax.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'lookup_postal_code',
                    postal_code: postalCode,
                },
                success: function (response) {
                    if (response.success) {
                        const { lat, lng } = response.data;

                        // Calculate distances and sort markersData by proximity
                        const sortedData = markersData.map(entry => {
                            const distance = getDistance(lat, lng, entry.coords.lat, entry.coords.lng);
                            return { ...entry, distance };
                        }).sort((a, b) => a.distance - b.distance);

                        // Clear existing markers
                        markers.forEach(marker => marker.setMap(null));
                        markers.length = 0;

                        // Add sorted markers to the map
                        displayMarkers(sortedData);

                        // Initialize pagination with sorted data
                        initializePagination(sortedData);

                        // Center the map on the postal code location
                        map.setCenter({ lat: lat, lng: lng });
                        map.setZoom(10);
                    } else {
                        // Handle error

                        $formError.show();

                    }
                },
                error: function (error) {
                    // Handle error
                    $formError.show();

                },
            });

            req.done(function () {
                $form.removeClass('-busy');
            });
        });
    }

    // Haversine distance calculation
    function getDistance(lat1, lon1, lat2, lon2) {
        const R = 6371; // Radius of the Earth in km
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Distance in km
    }

    function paginateItems(items, itemsPerPage, currentPage) {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        return items.slice(start, end);
    }

    function renderPage(items, itemsPerPage, currentPage, $locationsContainer, $allItems) {
        const paginatedItems = paginateItems(items, itemsPerPage, currentPage);
        $locationsContainer.empty();
        paginatedItems.forEach(entry => {
            const locationItem = $allItems.filter(`[data-id="${entry.id}"]`); // Find by data-id
            $locationsContainer.append(locationItem); // Reorder in the DOM
        });
    }

    const arrowIcon = `
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.70095 0.85996L6.32702 5.48603C6.6109 5.76991 6.6109 6.23017 6.32702 6.51405L1.70095 11.1401C1.41707 11.424 0.95681 11.424 0.672931 11.1401C0.389052 10.8562 0.389052 10.396 0.672931 10.1121L4.49134 6.29369L4.49134 5.70639L0.672931 1.88798C0.389052 1.6041 0.389052 1.14384 0.672931 0.85996C0.95681 0.576081 1.41707 0.576081 1.70095 0.85996Z" fill="#006937" stroke="#006937" stroke-width="0.698949"/>
        </svg>
    `;

    function createPager(totalPages, currentPage, renderPageCallback) {
        const $pager = $('#js-pager');
        $pager.empty();

        // Previous button
        if (currentPage > 1) {
            const $prevLink = $('<a class="page-numbers prev" href="#">').html(arrowIcon);
            $prevLink.on('click', function (e) {
                e.preventDefault();
                renderPageCallback(currentPage - 1);
            });
            $pager.append($prevLink);
        } else {
            const $prevLink = $('<span class="page-numbers prev">').html(arrowIcon);
            $pager.append($prevLink);
        }

        // Page links
        const startPage = Math.max(1, currentPage - 3);
        const endPage = Math.min(totalPages, currentPage + 3);

        for (let i = startPage; i <= endPage; i++) {
            const $pageLink = $('<a class="page-numbers" href="#">').text(i);
            if (i === currentPage) {
                $pageLink.addClass('current');
            }
            $pageLink.on('click', function (e) {
                e.preventDefault();
                renderPageCallback(i);
            });
            $pager.append($pageLink);
        }

        // Maximum number of pages
        if (endPage < totalPages) {
            const $maxPages = $('<a class="page-numbers max-pages" href="#">').text(`${totalPages}`);
            $maxPages.on('click', function (e) {
                e.preventDefault();
                renderPageCallback(totalPages);
            });
            $pager.append($maxPages);
        }

        // Next button
        if (currentPage < totalPages) {
            const $nextLink = $('<a class="page-numbers next" href="#">').html(arrowIcon);
            $nextLink.on('click', function (e) {
                e.preventDefault();
                renderPageCallback(currentPage + 1);
            });
            $pager.append($nextLink);
        } else {
            const $nextLink = $('<span class="page-numbers next">').html(arrowIcon);
            $pager.append($nextLink);
        }
    }

    // Helper functions
    function formatPhoneNumber(phone) {
        return `tel:${phone.replace(/[^\d+]/g, '')}`;
    }

    function extractDomain(url) {
        return url.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');
    }

    function ensureHttp(url) {
        if (!/^https?:\/\//i.test(url)) {
            return 'http://' + url;
        }
        return url;
    }

    function createLocationItem(entry) {
        return $('<div>')
            .addClass('m-locationItem js-locationItem')
            .attr('data-id', entry.id)
            .html(`
                <h4 class="u-cGreen">
                    ${entry.name || ''}
                </h4>
                ${entry.distance ? 
                    `<span class="m-locationItem__distance u-fs22">${window.postalCodeAjax.distance}: ${Math.round(entry.distance)} km</span>` 
                    : ''
                }
                <div class="m-locationItem__data u-fs22">
                    <div>
                        ${entry.address || ''}
                    </div>
                    <div>
                        ${entry.phone ? 
                            `<a href="${formatPhoneNumber(entry.phone)}" target="_blank" class="u-cBlack u-fw600">${entry.phone}</a><br/>` 
                            : ''
                        }
                        ${entry.website ? 
                            `<a target="_blank" href="${ensureHttp(entry.website)}" class="u-cBlack u-fw600">${extractDomain(entry.website)}</a>` 
                            : ''
                        }
                    </div>
                </div>
            `);
    }

    // Update the initializePagination function
    function initializePagination(items) {
        const $locationsContainer = $('.js-locations');
        
        // Clear container
        $locationsContainer.empty();
        
        // Create fresh location items
        const $allItems = items.map(item => createLocationItem(item));
        
        const itemsPerPage = 16;
        let currentPage = 1;
        const totalPages = Math.ceil(items.length / itemsPerPage);

        function renderPageCallback(page) {
            currentPage = page;
            const paginatedItems = paginateItems(items, itemsPerPage, currentPage);
            
            // Clear and render new page
            $locationsContainer.empty();
            paginatedItems.forEach((item, index) => {
                $locationsContainer.append($allItems[items.indexOf(item)].clone());
            });
            
            createPager(totalPages, currentPage, renderPageCallback);
        }

        createPager(totalPages, currentPage, renderPageCallback);
        renderPageCallback(currentPage);
    }

    // Start initializing the map (will wait for Google Maps API to load)
    initializeMap();

    // Initialize pagination on page load (doesn't require Google Maps)
    initializePagination(markersData);

});